export default {
    LOAD_TASK_TYPES(state, task_type) {
        state.items = task_type;
    }
}